import React from "react";
import { useParams } from "react-router-dom";
import { Container, Table } from "reactstrap";
import formations from "../../CommonData/Data/formation";
import StepGraphForDetail from "./Graph/StepGraphForDetail";

const StageDetail = () => {
    const { id } = useParams();
    let stage;

    // Recherche du stage dans toutes les formations
    for (const formation of formations) {
        stage = formation.stages.find((s) => s.id === parseInt(id, 10));
        if (stage) break;
    }

    if (!stage) {
        return (
            <Container>
                <h2>Stage introuvable</h2>
            </Container>
        );
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <h2> {stage.nom}</h2>
                    <br />
                    <StepGraphForDetail stageId={1} />
                    <Table className="table table-centered table-nowrap mb-0">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Étapes</th>
                                <th>Statut</th>
                                <th>Echecs</th>
                            </tr>
                        </thead>
                        <tbody>
                            {stage.steps.map((step) => (
                                <tr key={step.id}>
                                    <td>{step.id}</td>
                                    <td>{step.description}</td>
                                    <td>
                                        <span
                                            className={`badge ${step.fait
                                                ? "bg-success"
                                                : "bg-danger"
                                                }`}
                                        >
                                            {step.fait ? "Réussis" : "Echec"}
                                        </span>
                                    </td>
                                    <td>{step.erreurs}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default StageDetail;
